import React from 'react';
import { UiComponent } from 'components';
import { APPLICATION_TYPE_MAP, getApplicationBaseType, IEnroll } from 'types';

interface Props {
  targets: IEnroll[];
  isPending?: boolean;
  onSubmit: () => void;
}

/** 참석자 삭제 모달. targets 는 호출부에서 어드민 추가 유형만 걸러 넘긴다. */
function VolunteerDeleteModal({ targets, isPending, onSubmit }: Props) {
  return (
    <div css={{ minWidth: '360px' }}>
      <p css={{ fontSize: '13px', color: '#5f6069', marginBottom: '8px' }}>
        선택한 {targets.length}명을 삭제합니다. 되돌릴 수 없습니다.
      </p>

      <div
        css={{
          maxHeight: '200px',
          overflowY: 'auto',
          padding: '12px',
          background: '#fafafa',
          borderRadius: '6px',
          marginBottom: '16px',
          fontSize: '13px',
          lineHeight: 1.6,
        }}
      >
        {targets.map(({ id, user, applicationType }) => (
          <span key={id}>
            {user?.name}
            {applicationType &&
              `(${
                APPLICATION_TYPE_MAP[
                  getApplicationBaseType(
                    applicationType,
                  ) as keyof typeof APPLICATION_TYPE_MAP
                ] ?? applicationType
              })`}
            {id !== targets[targets.length - 1].id && ', '}
          </span>
        ))}
      </div>

      <div css={{ display: 'flex', gap: '0 8px', justifyContent: 'flex-end' }}>
        <UiComponent.Button
          color="primary"
          variant="contained"
          css={{ height: '35px' }}
          disabled={isPending}
          onClick={onSubmit}
        >
          삭제
        </UiComponent.Button>
      </div>
    </div>
  );
}

export default VolunteerDeleteModal;
